import { useMutation } from '@tanstack/vue-query'
import queryClient, { queryKeys } from '~/queryClient'
import financialBff from '~/services-v2/financial-bff/financial-bff'

export default function useInstallationSectionDelete(installationId: Ref<string | undefined>, _projectId?: Ref<string>) {
  const mutationKey = queryKeys.INSTALLATION.SECTION_DELETE(installationId.value as string)

  const mutationFn = async () => {
    if (!installationId.value) {
      throw new Error('Installation ID is required')
    }

    const res = await financialBff('mutation')({
      installation_section_delete: [
        {
          installation_id: installationId.value,
        },
        true,
      ],
    }, {
      operationName: 'InstallationSectionDocumentDelete',
    })

    return res.installation_section_delete
  }

  return useMutation({
    mutationKey,
    mutationFn,
    retry: 1,
    onSuccess: () => {
      if (!installationId.value)
        return

      queryClient.invalidateQueries({
        queryKey: queryKeys.INSTALLATION.COMMISSIONING_STATUS(installationId.value),
      })
    },
  })
}
